export default "__VITE_ASSET__BkD3KLtQ__"